const darkModeTheme = {
    palette: {
      mode: 'dark',
      primary: {
        main: '#2d319c',
      },
      secondary: {
        main: '#2196f3',
      },
      background: {
        default: '#121212',
        paper: '#1e1e1e',
      },
      text: {
        primary: '#ffffff',
        secondary: '#b3b3b3',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeight: 600,
      },
      h2: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeight: 600,
      },
      h3: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeight: 600,
      },
      h4: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeight: 600,
      },
      h5: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeight: 600,
      },
      h6: {
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        fontWeight: 600,
      },
      body1: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '1rem',
      },
      body2: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '0.875rem',
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            backgroundColor: '#1e1e1e',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '24px',
            textTransform: 'none',
            fontWeight: 600,
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: '#1e1e1e',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
          },
          head: {
            color: '#ffffff',
            fontWeight: 600,
          },
        },
      },
    },
  };
  
  export default darkModeTheme;